import { CellStyle } from 'ag-grid-community';
import { CSSProperties } from 'react';

export type TableDataFormat = 'string' | 'element' | 'currency' | 'percent' | 'number' | 'date' | 'datetime';

export type TableDatum<T> = TableData & T;

export type TableHeader<T> = {
    header?: string;
    headerValueGetter?: () => string | JSX.Element | undefined;
    cellRenderer?: (tableDatum: TableDatum<T>, header?: TableHeader<T>) => JSX.Element | string;
    hide?: boolean;
    className?: string;
    field?: keyof T | 'actions';
    elementField?: keyof T | 'actions';
    dataFormat?: TableDataFormat;
    displayDecimalPlaces?: number;
    width?: number;
    minimumWidth?: number;
    maximumWidth?: number;
    children?: TableHeader<T>[];
    pinned?: 'left' | 'right';
    wrap?: boolean;
    cellStyle?: CellStyle;
    handleGetCellClasses?: (tableDatum: TableDatum<T>, header?: TableHeader<T>) => string[];
};

export type TableData = {
    isVisible?: boolean;
    rowKey?: string | number;
};

export const stickyColumnStyle: CSSProperties = {
    position: 'sticky',
    zIndex: 2,
};
